import { useQuery } from '@tanstack/react-query'
import { AlarmClock, BookCopy, BookOpen, CircleDollarSign } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { StatCard } from '@/components/ui/StatCard'
import { libraryStatsQuery } from '@/features/library/api'
import { formatMoney, formatNumber } from '@/utils/format'

export function LibraryStatsRow() {
  const { t } = useTranslation('library')
  const { data, isPending } = useQuery(libraryStatsQuery())
  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <StatCard
        label={t('Titles')}
        value={formatNumber(data?.titles)}
        icon={<BookOpen />}
        loading={isPending}
        hint={
          data
            ? t('{{formatted}} copies in stock', { count: data.copies, formatted: formatNumber(data.copies) })
            : undefined
        }
      />
      <StatCard
        label={t('On loan')}
        value={formatNumber(data?.onLoan)}
        icon={<BookCopy />}
        tone="info"
        loading={isPending}
        hint={
          data && data.copies
            ? t('{{pct}}% of copies', { pct: Math.round((data.onLoan / data.copies) * 100) })
            : undefined
        }
      />
      <StatCard
        label={t('Overdue')}
        value={formatNumber(data?.overdue)}
        icon={<AlarmClock />}
        tone={data?.overdue ? 'danger' : 'success'}
        loading={isPending}
        hint={t('Past their due date')}
      />
      <StatCard
        label={t('Fines outstanding')}
        value={data ? formatMoney(data.finesOutstanding, data.currency) : '—'}
        icon={<CircleDollarSign />}
        tone="warning"
        loading={isPending}
        hint={t('Recorded at return, unpaid')}
      />
    </div>
  )
}
